<template>
    <modal v-model="opened" :transition='0' :append-to-body="true" :backdrop="false">
        <template #header>
            <div>
                <a id="close_popup" @click="close_popup"></a>
                <h3 class="modal-title">Find event Occurrence</h3>
            </div>
        </template>
        <div class="row" v-if="opened">
            <div class="col-sm-12 text-center">
                <date-input
                        :model-value="picked"
                        :multi-dates="allowMultiple"
                        :disabled-dates="unavailableDates"
                        :start-date="openDate"
                        :inline="true"
                        @update:model-value="onPicked"
                        @update-month-year="onChangedMonth"
                ></date-input>
            </div>
        </div>

        <template #footer>
            <div>
                <button class="btn btn-mm" @click="close_popup">Cancel</button>
                <button class="btn btn-mm btn-green" :disabled="!allowSave" @click="save">OK</button>
            </div>
        </template>
    </modal>
</template>

<script>
    import moment from 'moment';
    import DateInput from '~/vue/common_components/DateInput';
    import {VISUAL_DATE_FORMAT} from "../new_calendar/config";
    import CalendarEventsResource from '~/angular/app/events/calendar_events_recource';

    export default {
        name: "EventFindOccurrencePopup",
        components: {DateInput},
        props: {
            allowMultiple: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                eventDate: undefined,

                opened: false,

                eventId: undefined,
                calendarOwnerId: undefined,
                date: undefined,

                openDate: undefined,

                loading: false,
                availableDates: [],
                activeMonth: undefined,
                activeYear: undefined,

                selectedDates: [],
            };
        },
        computed: {
            // picking is what shows a date as picked now, so the days chosen so far no
            // longer have to be drawn by hand as highlighted ones
            picked() {
                if (this.allowMultiple) {
                    return this.selectedDates.map(d => moment(d, VISUAL_DATE_FORMAT).toDate());
                } else {
                    return this.eventDate;
                }
            },
            unavailableDates() {
                const dates = [];
                const dateInMonth = moment(new Date(this.activeYear, this.activeMonth, 1));
                while (dateInMonth.month() === this.activeMonth) {
                    if (!this.availableDates.includes(dateInMonth.format(VISUAL_DATE_FORMAT))) {
                        dates.push(dateInMonth.toDate());
                    }
                    dateInMonth.add(1, 'd');
                }
                return dates;
            },
            allowSave() {
                if (this.allowMultiple) {
                    return this.selectedDates.length;
                } else {
                    return true;
                }
            }
        },
        methods: {
            resetData() {
                this.eventDate = undefined;
                this.activeYear = undefined;
                this.activeMonth = undefined;
                this.openDate = undefined;
                this.loading = false;
                this.availableDates = [];
                this.selectedDates = [];
            },
            loadEventsInMonth(rawDate) {
                this.activeMonth = rawDate.getMonth();
                this.activeYear = rawDate.getFullYear();
                this.loading = true;
                CalendarEventsResource.get_event_occurrences_in_month(this.eventId, this.calendarOwnerId, this.date.format(VISUAL_DATE_FORMAT), moment(rawDate).format(VISUAL_DATE_FORMAT))
                    .then(resp => {
                        this.availableDates = resp.data;
                        this.loading = false;
                    });
            },
            show(calendarOwnerId, eventId, date, preSelectedDates = []) {
                this.eventId = eventId;
                this.selectedDates = preSelectedDates.map(d => d);
                this.date = date;
                this.openDate = date.toDate();
                this.calendarOwnerId = calendarOwnerId;
                if (!this.allowMultiple) {
                    this.eventDate = this.date.toDate();
                }
                this.opened = true;
                this.loadEventsInMonth(this.date.toDate());
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                });
            },
            close_popup() {
                this.opened = false;
                this.reject('closed');
                this.resetData();
            },
            onChangedMonth({month, year}) {
                if (!this.opened) {
                    return;
                }
                this.loadEventsInMonth(new Date(year, month, 1));
            },
            save() {
                if (!this.allowMultiple) {
                    this.resolve(this.eventDate.format(VISUAL_DATE_FORMAT));
                } else {
                    this.resolve(this.selectedDates);
                }
                this.opened = false;
                this.resetData();
            },
            // `multi-dates` does the adding and removing itself, so this is only the
            // translation back to the formatted dates the popup resolves with
            onPicked(value) {
                if (this.allowMultiple) {
                    this.selectedDates = (value || []).map(d => moment(d).format(VISUAL_DATE_FORMAT));
                } else {
                    this.eventDate = value;
                }
            }
        }
    };
</script>
